module.exports = __webpack_public_path__ + "static/bgAsset-px-0e1523add79d1a266aa190f9665b0b94.jpg";